export default __webpack_public_path__ + "static/media/Datenschutzerklaerung.cfb2dede.pdf";